import React from 'react';
import { ErrorAlertProps } from '../../types/components';

/**
 * A reusable error alert component
 */
function ErrorAlert({ message }: ErrorAlertProps) {
  if (!message) return null;
  
  return (
    <div className="alert alert-danger shadow-sm" role="alert">
      <i className="bi bi-exclamation-triangle me-2"></i>
      {message}
    </div>
  );
}

export default ErrorAlert; 